<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="Commodity distribution" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <mt-button slot="right"  @click="goAdd">Add</mt-button>
            </mt-header>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div v-if="goods_list">
        <div v-if="goods_list.length">
        <div  v-for="item in goods_list" :key="item.goods_commonid" @click="onEdit(item.goods_commonid)" class="mb-5">
            <mt-cell :title="item.goods_name" class="pt-5 pb-5">
                <span class="inviter_info"><em>{{item.inviter_total_quantity}} pieces distributed</em><em>Total amount{{item.inviter_total_amount}}</em><em>Total Commission {{item.inviter_amount}}</em></span>
                <i class="iconfont">&#xe650;</i>
            </mt-cell>
        </div>
        </div>
        <empty-record v-else></empty-record>
        </div>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getInviterGoodsList } from '../../../api/sellerInviter'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  name: 'GoodsList',
  data () {
    return {
    params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      // 分销商品列表
      goods_list: false
    }
  },
  components: {
    EmptyRecord
  },
  created: function () {
  
  },
  methods: {
    goAdd () {
      this.$router.push({ name: 'SellerInviterGoodsForm', query: { action: 'add' } })
    },
    onEdit (goods_commonid) {
      this.$router.push({ name: 'SellerInviterGoodsForm', query: { goods_commonid: goods_commonid } })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getGoodsList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.goods_list = []
      this.loadMore()
    },
    getGoodsList () {
      getInviterGoodsList(this.params).then(res => {
        if (this.goods_list) {
              this.goods_list = this.goods_list.concat(res.result.goods_list)
          } else {
              this.goods_list = res.result.goods_list
          }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped>
.inviter_info{width:4.2rem;}
.inviter_info em{line-height:1rem;display:block;width:100%;}
</style>
